import axios from "axios";
import backendUrl from "./constant/backendUrl";


export async function insertAgent(formData){
    let url = `${backendUrl}/Agent/Create`;
   return  axios.post(url, formData)
}
